import { createUseStyles } from 'react-jss';
import { LoaderVariants } from '../types/index.js';
import { PrimaryColors } from '../../../../foundation/colors/primaryColors/primaryColors/index.js';
import { Timings } from '../../../../foundation/timings/timings/index.js';
import { Easing } from '../../../../foundation/easing/easing/index.js';
import { BackgroundColors } from '../../../../foundation/colors/backgroundColors/backgroundColors/index.js';
import { BreakPointsMedia } from '../../../../foundation/responsive/responsive/index.js';

const useStyles = createUseStyles({
    '@keyframes rotate': {
        to: {
            transform: 'rotate(360deg)',
        },
    },
    [LoaderVariants.Local]: {
        position: 'absolute',
    },
    [LoaderVariants.Global]: {
        position: 'fixed',
    },
    root: {
        display: 'flex',
        width: '100%',
        height: '100%',
        inset: 0,
        zIndex: ({ zIndex }) => zIndex,
        backgroundColor: ({ isWithoutBackground }) => !isWithoutBackground && BackgroundColors.transparent,
    },
    icon: {
        display: 'inline-block',
        margin: 'auto',
        width: ({ sizes }) => sizes?.Default.value?.size,
        height: ({ sizes }) => sizes?.Default.value?.size,
        animation: `$rotate ${Timings.long} ${Easing.linear} infinite`,
        [BreakPointsMedia.XXL]: {
            width: ({ sizes }) => sizes?.XXL.value?.size,
            height: ({ sizes }) => sizes?.XXL.value?.size,
        },
        [BreakPointsMedia.XL]: {
            width: ({ sizes }) => sizes?.XL.value?.size,
            height: ({ sizes }) => sizes?.XL.value?.size,
        },
        [BreakPointsMedia.LG]: {
            width: ({ sizes }) => sizes?.LG.value?.size,
            height: ({ sizes }) => sizes?.LG.value?.size,
        },
        [BreakPointsMedia.MD]: {
            width: ({ sizes }) => sizes?.MD.value?.size,
            height: ({ sizes }) => sizes?.MD.value?.size,
        },
        [BreakPointsMedia.SM]: {
            width: ({ sizes }) => sizes?.SM.value?.size,
            height: ({ sizes }) => sizes?.SM.value?.size,
        },
        [BreakPointsMedia.XS]: {
            width: ({ sizes }) => sizes?.XS.value?.size,
            height: ({ sizes }) => sizes?.XS.value?.size,
        },
        [BreakPointsMedia.XXS]: {
            width: ({ sizes }) => sizes?.XXS.value?.size,
            height: ({ sizes }) => sizes?.XXS.value?.size,
        },
        '& path': {
            fill: PrimaryColors.base.default,
        },
    },
}, {
    name: 'loader',
});

export { useStyles };
